import { ClickoutUrl } from '@/helpers/clickout-helper';

import { useExperiment } from '@/libraries/experiment';

export function useRevenueCheckExp() {
	const { activeVariantWithControlGroup } = useExperiment('INT_OFFERS_REVENUE_CHECK_EXP');

	function setAffiliateTagForRevenueExp(url: ClickoutUrl) {
		if (!activeVariantWithControlGroup.value) return url;

		switch (activeVariantWithControlGroup.value) {
			case 'control':
				url.setOnOffer('tag', `justgb-noexp-control-21`);
				break;
			case 'variant_1':
				url.setOnOffer('tag', `justgb-noexp-v1-21`);
				break;
			case 'variant_2':
				url.setOnOffer('tag', `justgb-noexp-v2-21`);
				break;
		}

		return url.skipYieldOptimization().skipUCT2();
	}

	return {
		setAffiliateTagForRevenueExp,
	};
}
